'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _soundMuted = require('./soundMuted.scss');

var _soundMuted2 = _interopRequireDefault(_soundMuted);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SoundMuted = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(SoundMuted, _React$Component);

  function SoundMuted(props) {
    (0, _classCallCheck3.default)(this, SoundMuted);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SoundMuted.__proto__ || (0, _getPrototypeOf2.default)(SoundMuted)).call(this, props));

    _this.clickMuted = _this.clickMuted.bind(_this);

    return _this;
  }

  (0, _createClass3.default)(SoundMuted, [{
    key: 'clickMuted',
    value: function clickMuted() {
      this.props.handleCarouselChangeMute(!this.props.mute);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          anioActive = _props.anioActive,
          handleCarouselChangeMute = _props.handleCarouselChangeMute,
          mute = _props.mute;

      // let classSoundMutedBtn = classNames({
      //   "soundMuted__btn" : true,
      //   "icon-unmute": anioActive === null,
      //   "icon-mute": anioActive === 'left' || anioActive === 'right'
      // });

      var classSoundMutedBtn = (0, _classnames2.default)({
        "soundMuted__btn": true,
        "icon-unmute": mute,
        "icon-mute": !mute
      });

      return _react2.default.createElement(
        'div',
        { className: 'soundMuted' },
        _react2.default.createElement('button', { className: classSoundMutedBtn, onClick: this.clickMuted })
      );
    }
  }]);
  return SoundMuted;
}(_react2.default.Component), _class.propTypes = {
  name: _propTypes2.default.string
}, _temp);
exports.default = SoundMuted;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SoundMuted/SoundMuted.jsx
// module id = 709
// module chunks = 0